import { getCountries, getCadenceCountries } from '../../services/country.service';

export const GET_COUNTRIES_LIST = 'GET_COUNTRIES_LIST';
export const GET_COUNTRIES_LIST_SUCCESS = 'GET_COUNTRIES_LIST_SUCCESS';
export const GET_CADENCE_COUNTRIES_LIST = 'GET_CADENCE_COUNTRIES_LIST';
export const GET_CADENCE_COUNTRIES_LIST_SUCCESS = 'GET_CADENCE_COUNTRIES_LIST_SUCCESS';

export function getCountriesList() {
  return async dispatch => {
    dispatch({
      type: GET_COUNTRIES_LIST,
    });

    try {
      const countries = await getCountries();

      dispatch({
        type: GET_COUNTRIES_LIST_SUCCESS,
        countries,
      });
    } catch (err) {
      dispatch({
        type: GET_COUNTRIES_LIST_SUCCESS,
        countries: [],
      });
    }
  };
}

export function getCadenceCountriesList() {
  return async dispatch => {
    dispatch({
      type: GET_CADENCE_COUNTRIES_LIST,
    });

    try {
      const countries = await getCadenceCountries();

      dispatch({
        type: GET_CADENCE_COUNTRIES_LIST_SUCCESS,
        countries,
      });
    } catch (err) {
      dispatch({
        type: GET_CADENCE_COUNTRIES_LIST_SUCCESS,
        countries: [],
      });
    }
  };
}
